import { useEffect } from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function OnboardingSuccess() {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.replace('/landing');
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="text-center max-w-md space-y-6">
        <div className="flex justify-center">
          <div className="w-24 h-24 rounded-full bg-green-500/20 flex items-center justify-center">
            <CheckCircle2 className="w-12 h-12 text-green-400" />
          </div>
        </div>
        <div>
          <h1 className="font-space font-bold text-3xl text-foreground mb-3">Thank You for Applying!</h1>
          <p className="text-muted-foreground leading-relaxed">
            Your application has been submitted to GF Trucklines. Our team will review your information and reach out to you soon.
          </p>
        </div>
        <div className="glass-card p-4 rounded-xl text-sm text-muted-foreground space-y-1">
          <p>What happens next:</p>
          <ul className="text-left space-y-1 mt-2">
            <li className="flex items-start gap-2"><span className="text-primary mt-0.5">•</span> Our team reviews your application</li>
            <li className="flex items-start gap-2"><span className="text-primary mt-0.5">•</span> You'll be contacted for next steps</li>
            <li className="flex items-start gap-2"><span className="text-primary mt-0.5">•</span> Once approved, your portal will be activated</li>
          </ul>
        </div>
        <p className="text-xs text-muted-foreground">Redirecting to home in 5 seconds…</p>
      </div>
    </div>
  );
}